import { RootState } from "store";
import { TableSummariesState } from "./tables.types";

export function selectTablesPagination(state: RootState) {
  const { total, page } = state.products.tables;

  return { total, page };
}

export function selectTableSummaries(state: RootState): TableSummariesState {
  return state.products.tables.summaries;
}

export function moreTablesToLoad(state: RootState): boolean {
  const { total } = selectTablesPagination(state);
  const tableCount = state.products.tables.allIds.length;

  return total > tableCount;
}
